module.exports = __webpack_public_path__ + "static/media/levelCompleteSound.59a4cc8c.mp3";